/* eslint-disable max-len */
import { getBudgetService } from '../../services/yclickMaster';
import {
  getUbicationDetail as getUbicationDetailService,
  getUbicationDetailOyM as getUbicationDetailOyMService,
  putUbicationDetail as putUbicationDetailService,
  putUbicationDetailOyM as putUbicationDetailOyMService,
  putAssignationProvider as putAssignationProviderService,
  postProviders as postProvidersService,
  getMessages as getMessagesService,
  sendMessage as sendMessageService,
  postPendingAuthorization as postPendingAuthorizationService,
  postPendingAuthorizationCalendar as postAuthorizationCalendarService
} from '../../services/serviceRequest';
import { postWorkReport as postWorkReportService } from '../../services/workReport';
import {
  getMessagesMonthly,
  sendMessageMonthly,
  putUbicationMonthlyDetailService,
  putUbicationMonthlyOyMDetailService
} from '../../services/monthlyServiceRequest';
import { imputationTypeEnum } from '../../utils/dataStatus';
import { mapperAccountAssignmentObject } from '../../utils/mapper';

// GET UBICATION DETAILS
export const getUbicationDetail = async (id) =>
  new Promise((resolve, reject) => {
    // To build wells data, we must first fetch budgets for each well
    getUbicationDetailService(id)
      .then((data) => {
        const resBudget = data?.pozos?.map((well) =>
          well.tipoImputacion.id === imputationTypeEnum.PEP
            ? getBudgetService(well.objetoImputacion.id)
            : null
        );

        Promise.all(resBudget)
          .then((values) => {
            const wells =
              mapperAccountAssignmentObject({ wells: data.pozos, budget: values }) || [];
            const dataAdapter = {
              imputationObject: {
                wells,
                editaPozosLocacion: data?.editaPozosLocacion,
                esSoloAprobador: data?.esSoloAprobador
              }
            };

            resolve(dataAdapter);
          })
          .catch(() => {
            const wells = mapperAccountAssignmentObject({ wells: data?.pozos }) || [];
            const dataAdapter = {
              imputationObject: {
                wells
              }
            };

            resolve(dataAdapter);
          });
      })
      .catch((err) => reject(err));
  });

export const getUbicationDetailOyM = async (id) =>
  new Promise((resolve, reject) => {
    // To build wells data, we must first fetch budgets for each well
    getUbicationDetailOyMService(id)
      .then((data) => {
        const resBudget = [data]?.map((well) =>
          well.tipoImputacion.id === imputationTypeEnum.PEP
            ? getBudgetService(well.objetoImputacion.id)
            : null
        );

        Promise.all(resBudget)
          .then((values) => {
            const wells = mapperAccountAssignmentObject({ wells: [data], budget: values }) || [];
            const dataAdapter = {
              imputationObject: {
                wells
              }
            };

            resolve(dataAdapter);
          })
          .catch(() => {
            const wells = mapperAccountAssignmentObject({ wells: [data] }) || [];
            const dataAdapter = {
              imputationObject: {
                wells
              }
            };

            resolve(dataAdapter);
          });
      })
      .catch((err) => reject(err));
  });

const mapperUpdateWells = (wells) =>
  wells?.map((well) => ({
    idSolicitudServicioPozo: well?.serviceRequestId || well?.idMonthlyWellServiceRequest,
    idPozo: well?.well?.id,
    pozoStr: well?.well?.nombre,
    idEquipo: well?.team?.id,
    tipoImputacionEnum: well?.imputationType?.id,
    idObjetoImputacion: well?.imputationObject?.id,
    idEventoPozo: well?.event?.eventoPozoId,
    idEvento: well?.event?.id,
    eliminado: well?.eliminado ?? false
  }));

const mapperUpdateOyMWells = (wells) =>
  wells?.map((well) => ({
    tipoImputacionId: well?.imputationType?.id,
    objetoImputacionId: well?.imputationObject?.id
  }));

// UPDATE UBICATION DETAILS
export const putUbicationDetail = async (wells, requestId) => {
  const paramsAfter = mapperUpdateWells(wells);

  return new Promise((resolve, reject) => {
    putUbicationDetailService(requestId, paramsAfter)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });
};

export const putUbicationMonthlyDetail = async ({ wells, requestId, isOyM }) => {
  const paramsAfter = mapperUpdateWells(wells);

  if (!isOyM)
    return new Promise((resolve, reject) => {
      putUbicationMonthlyDetailService(requestId, paramsAfter)
        .then((data) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });

  return new Promise((resolve, reject) => {
    putUbicationMonthlyOyMDetailService(requestId, {
      pozoId: wells[0]?.well?.id,
      tipoId: wells[0]?.imputationType?.id,
      objetoId: wells[0]?.imputationObject?.id
    })
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });
};

export const putUbicationDetailOyM = async (wells, requestId) => {
  const paramsAfter = mapperUpdateOyMWells(wells);

  return new Promise((resolve, reject) => {
    putUbicationDetailOyMService(requestId, paramsAfter[0])
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });
};

//
// ASSIGN PROVIDER
export const putAssignationProvider = async (
  id,
  providerId,
  providerName,
  reassignmentReason = null
) =>
  new Promise((resolve, reject) => {
    putAssignationProviderService(id, providerId, providerName, reassignmentReason)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });

// POST PROVIDERS
export const postProviders = async (params, id) => {
  const paramsAfter = params?.map((provider) => ({
    idSolicitudServicioProveedor: id,
    idProveedor: provider.provider.id,
    idUnidadNegocio: provider.businessUnit.id,
    idContrato: provider.contract.id,
    // the contract it's like '23423423 (vencido)'
    numeroContrato: provider.contract.nombre.split(' ')[0],
    tipoNotificacionEnum: provider.notificate.id,
    requiereAceptacion: provider.contract.requiereAceptacion,
    requiereAdjuntarArchivo: provider.contract.requiereAdjuntarArchivo
  }));

  return new Promise((resolve, reject) => {
    postProvidersService(paramsAfter, id)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });
};

export const getMessages = (id, skip, isMonthly) =>
  new Promise((resolve, reject) => {
    if (isMonthly) {
      getMessagesMonthly(id, skip)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    } else {
      getMessagesService(id, skip)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    }
  });

export const sendMessage = (id, param, isMonthly) =>
  new Promise((resolve, reject) => {
    if (isMonthly) {
      sendMessageMonthly(id, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    } else {
      sendMessageService(id, param)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    }
  });

// Work Report
export const postWorkReport = async ({ id, startDate, numberDays }) => {
  const paramsAfter = {
    idSolicitudServicio: id,
    cantDias: Number(numberDays),
    fechaInicio: startDate
  };

  return new Promise((resolve, reject) => {
    postWorkReportService(paramsAfter)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });
};

// Pending Authorization
export const postPendingAuthorization = async ({ id, fechaDesde, fechaHasta, contractNumber }) => {
  const body = {
    idSolicitud: id,
    fechaDesde,
    fechaHasta,
    numeroContrato: contractNumber
  };

  return new Promise((resolve, reject) => {
    postPendingAuthorizationService(body)
      .then((data) => {
        // Data comes grouped by ubication in costosPendientes, in SDS or ASDS we need get only the first ubication in costosPendientes
        if (data?.mensaje?.length) {
          reject(data);
        } else {
          const adaptedResponse = {
            mensaje: data.mensaje,
            permitirAutorizacion: data.permitirAutorizacion,
            lineas: data.costosPendientes ? data.costosPendientes[0]?.lineas : [],
            montoPendiente: data.costosPendientes
              ? data.costosPendientes[0].montoPendiente
              : '0,00',
            contieneArchivosAdjuntos: data?.costosPendientes[0]?.contieneArchivosAdjuntos,
            objetoImputacion: data?.objetoImputacion ?? data.costosPendientes[0]?.objetoImputacion
          };

          resolve(adaptedResponse);
        }
      })
      .catch((err) => reject(err));
  });
};

export const postCalendarData = ({ id, contractNumber }) => {
  const body = {
    idSolicitud: id,
    numeroContrato: contractNumber
  };

  return new Promise((resolve, reject) => {
    postAuthorizationCalendarService(id, body)
      .then((data) => {
        const adaptedResponse = {
          firstDate: data.primeraFecha,
          lastDate: data.ultimaFecha,
          calendarDates: data.fechasCalendario
        };

        resolve(adaptedResponse);
      })
      .catch((err) => reject(err));
  });
};

export default {
  getUbicationDetail,
  putUbicationDetail,
  putAssignationProvider,
  postProviders,
  postWorkReport
};
